/* src/app/shared/components/ngx-responsive-table/components/density-controls/density-controls.component.scss */
.density-controls .density-items {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-end;
}
.density-controls .density-items .density-item {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  justify-content: space-between;
  width: 36px;
  height: 21px;
  padding: 0 4px;
  cursor: pointer;
}
.density-controls .density-items .density-item:hover span,
.density-controls .density-items .density-item.active span {
  background-color: #595555;
}
.density-controls .density-items .density-item span {
  background-color: #d9d9d6;
  display: flex;
  width: 100%;
}
.density-controls .density-items .density-item.loose span {
  height: 5px;
}
.density-controls .density-items .density-item.tight span {
  height: 3px;
}
/*# sourceMappingURL=density-controls.component.css.map */
